import { ReactComponent as Proposito } from "assets/svgs/icon-proposito.svg"
import { ReactComponent as PropostaValor } from "assets/svgs/icon-proposta-valor.svg"
import { ReactComponent as Ambicao } from "assets/svgs/icon-ambicao.svg"
import { ReactComponent as Visao } from "assets/svgs/icon-visao.svg"
import { ReactComponent as Missao } from "assets/svgs/icon-missao.svg"
import { ReactComponent as ValorCardeal } from "assets/svgs/icon-valor-cardeal.svg"
import { ReactComponent as Responsabilidade } from "assets/svgs/icon-responsabilidade.svg"
import { ReactComponent as Cooperacao } from "assets/svgs/icon-cooperacao.svg"
import { ReactComponent as Expertise } from "assets/svgs/icon-expertise.svg"
import { ReactComponent as Agilidade } from "assets/svgs/icon-agilidade.svg"
import { ReactComponent as Abertura } from "assets/svgs/icon-abertura-aos-outros.svg"

import { ReactComponent as PropositoMobile } from "assets/svgs/icon-proposito-mobile.svg"
import { ReactComponent as PropostaValorMobile } from "assets/svgs/icon-proposta-valor-mobile.svg"
import { ReactComponent as AmbicaoMobile } from "assets/svgs/icon-ambicao-mobile.svg"
import { ReactComponent as VisaoMobile } from "assets/svgs/icon-visao-mobile.svg"
import { ReactComponent as MissaoMobile } from "assets/svgs/icon-missao-mobile.svg"
import { ReactComponent as ValorCardealMobile } from "assets/svgs/icon-valor-cardeal-mobile.svg"
import { ReactComponent as ResponsabilidadeMobile } from "assets/svgs/icon-responsabilidade-mobile.svg"
import { ReactComponent as CooperacaoMobile  } from "assets/svgs/icon-cooperacao-mobile.svg"
import { ReactComponent as ExpertiseMobile  } from "assets/svgs/icon-expertise-mobile.svg"
import { ReactComponent as AgilidadeMobile  } from "assets/svgs/icon-agilidade-mobile.svg"
import { ReactComponent as AberturaMobile  } from "assets/svgs/icon-abertura-aos-outros-mobile.svg"

export const CorporativeCultureConstants = [
    {
        topic: "Plataforma de marca",
        img: <Proposito />,
        imgMobile: <PropositoMobile />,
        title: "Propósito",
        paragraph: (
            <>
                Somos uma companhia seguradora e um investidor responsável,
                que atua com nossos parceiros em prol de uma sociedade inclusiva e sustentável.
                Motivados pela vocação cidadã do nosso grupo, fornecemos às pessoas soluções que
                protegem e facilitam todas as jornadas de vida.
            </>
        )
    },
    {
        topic: "Plataforma de marca",
        img: <PropostaValor />,
        imgMobile: <PropostaValorMobile />,
        title: "Proposta de valor",
        paragraph: (
            <>
                Oferecer, com excelência, serviços e produtos de seguridade úteis para cuidar
                dos diversos momentos de vida das pessoas.
            </>
        )
    },
    {
        topic: "Plataforma de marca",
        img: <Ambicao />,
        imgMobile: <AmbicaoMobile />,
        title: "Ambição",
        paragraph: (
            <>
                Ser a seguradora mais útil para cada
                uma das nossas partes interessadas.
            </>
        )
    },
    {
        topic: "Plataforma de marca",
        img: <Visao />,
        imgMobile: <VisaoMobile />,
        title: "Visão",
        paragraph: (
            <>
                As grandes mudanças demográficas, ambientais e digitais despertam
                tanto aspirações quanto riscos de divisões e exclusões de indivíduos,
                e temos um papel a desempenhar para protegê-los.
            </>
        )
    },
    {
        topic: "Plataforma de marca",
        img: <Missao />,
        imgMobile: <MissaoMobile />,
        title: "Missão",
        paragraph: (
            <>
                Fornecer soluções de proteção para o maior número possível de
                pessoas e, assim, proteger tudo que é importante para
                elas ao longo do tempo.
            </>
        )
    },
    {
        topic: "Plataforma de marca",
        img: <ValorCardeal />,
        imgMobile: <ValorCardealMobile />,
        title: "Valor cardeal",
        paragraph: (
            <>
                Abertura aos outros e ao mundo.
            </>
        )
    },
    {
        topic: "Valores",
        img: <Responsabilidade/>,
        imgMobile: <ResponsabilidadeMobile />,
        title: "Responsabilidade",
        paragraph: (
            <>
                Somos responsáveis, íntegros e cuidamos do mundo hoje e para
                as próximas gerações.
            </>
        )
    },
    {
        topic: "Valores",
        img: <Cooperacao/>,
        imgMobile: <CooperacaoMobile />,
        title: "Cooperação",
        paragraph: (
            <>
                Somos um time unido e trabalhamos em cooperação com nossos parceiros para
                oferecer as melhores soluções para eles e para os clientes.
            </>
        )
    },
    {
        topic: "Valores",
        img: <Expertise/>,
        imgMobile: <ExpertiseMobile />,
        title: "Expertise",
        paragraph: (
            <>
                Somos especialistas no que fazemos, eficientes, adaptáveis e fornecemos
                soluções úteis e confiáveis
            </>
        )
    },
    {
        topic: "Valores",
        img: <Agilidade/>,
        imgMobile: <AgilidadeMobile />,
        title: "Agilidade",
        paragraph: (
            <>
                Somos ágeis, simples, inovadores e entregamos soluções que criam valor em
                todas as nossas relações.
            </>
        )
    },
    {
        topic: "Valores",
        img: <Abertura/>,
        imgMobile: <AberturaMobile />,
        title: "Abertura aos outros e ao mundo",
        paragraph: (
            <>
                Somos feitos de gente pra gente, abertos ao mundo através dos olhos
                dos nossos clientes e comprometidos em responder às necessidades da
                sociedade.
            </>
        )
    },
]